import Vue from 'vue'
import _get from 'lodash/get'
import Api from '@/services/Api'
import { bugsnagClient } from '@/services/ErrorHandler'

/**
 * Returns the asset path
 * @param path
 * @function
 * @name $asset
 * @memberOf Vue
 * @returns {string}
 */
Vue.prototype.$asset = (path) => {
  return '@/assets/' + path
}

Vue.prototype.$api = Api

Vue.prototype.$safeGet = _get
/**
 * General error handler
 * @param {Error|AxiosError} error
 * @param {Boolean|Array} skipReport - skip the report if True or status is included in the array
 */
Vue.prototype.$displayError = function displayError (error, skipReport) {
  let shouldSkipReporting = false
  const status = _get(error, 'response.status', 0)
  const { message = '', errors = {} } = _get(error, 'response.data.data', {})
  let errorsArray = Object.values(errors)
  if (typeof skipReport === 'boolean') {
    shouldSkipReporting = skipReport
  } else if (Array.isArray(skipReport) && skipReport.includes(status)) {
    shouldSkipReporting = true
  }
  if (!shouldSkipReporting) {
    bugsnagClient.notify(error, {
      metaData: {
        responseMessage: message,
        apiResponse: {
          message: message,
          errors: errors
        }
      }
    })
  }
  if (errorsArray.length) {
    this.$notify.fire({
      type: 'error',
      html: errorsArray.map(error => `<div>${error.join('')}</div>`).join('')
    })
    return
  }
  this.$notify.error(message || error.message)
}

Vue.prototype.$reportError = (error) => bugsnagClient.notify(error)
